function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m85.1 59.2-3.4-1.6c-6.9-3.3-11.9-9.6-13.3-16.9-.3-1.8-.5-3.5-.3-4.9l.2-2.4-34.7-16.4-15.3 32.4c-1.5 3.2-1.7 6.9-.5 10.2 1.2 3.4 3.7 6.1 6.9 7.6l2.8 1.3-2.2 4.7 6.3 3 2.2-4.7 12.6 5.9-2.2 4.7 6.3 3 2.2-4.7 12.6 5.9-2.3 4.9 6.3 3 2.2-4.7 12.6 5.9-2.2 4.7 6.3 3 2.2-4.7 7.2 3.4 1.5-3.2c7.1-14.7.7-32.4-14-39.4zm9 33.1-66.4-31.4c-1.5-.7-2.7-2-3.3-3.6s-.5-3.3.2-4.9l12.4-26.1 24 11.4c0 1.4.2 2.8.5 4.3.1.3.1.6.2 1l-13 6.6 3.2 6.2 12.1-6.2c.8 1.5 1.7 3 2.7 4.4l-11.7 6.7 3.5 6.1 13.1-7.5c2.1 1.8 4.5 3.4 7 4.6l3.4 1.6c10.3 4.9 15.2 16.4 12.1 26.8z",
  fill: "#015168",
  fillRule: "evenodd"
});

var SvgReittiYli3Km = function SvgReittiYli3Km(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120 120",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReittiYli3Km, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reitti-yli-3km.5619fc32.svg";
export { ForwardRef as ReactComponent };